import React, { useCallback } from 'react';
import {
    DYF_SIGNIN_REGEX_ENG,
    DYF_SIGNIN_REGEX_FR,
} from '../../../../constants';
import './sign-in-replace-component.scss';

const signInRegexMatcher = (inputString: string): string => {
    const matchEng = inputString?.match(DYF_SIGNIN_REGEX_ENG);
    const matchFr = inputString?.match(DYF_SIGNIN_REGEX_FR);

    if (matchEng) {
        return matchEng[0];
    } else if (matchFr) {
        return matchFr[0];
    } else {
        return '';
    }
};

const replaceJSX = (
    originalString: string,
    find: string,
    replace: React.JSX.Element
): React.JSX.Element => {
    const returnValue =
        originalString &&
        originalString.split(find).flatMap((item: any) => [item, replace]);

    return (returnValue?.slice(0, -1) as unknown) as React.JSX.Element;
};

interface BodyTextProps {
    handleLogin: () => void;
    description: string;
    bolded?: boolean;
}

export const SignInReplaceComponent = (props: BodyTextProps) => {
    const handleLogin = useCallback(() => props.handleLogin(), [
        props.handleLogin,
    ]);

    return replaceJSX(
        props.description,
        signInRegexMatcher(props.description),
        <a
            className={`sign-in-link ${props.bolded && 'bold'}`}
            data-testid={'ymm-sign-in-link'}
            tabIndex={0}
            onClick={handleLogin}
        >
            {signInRegexMatcher(props.description)}
        </a>
    );
};
